import Iconix1 from '../../../Media/Ruko BSD/Iconix/Iconix (1).webp'
import Iconix2 from '../../../Media/Ruko BSD/Iconix/Iconix (2).webp'

const Iconiximages =[
Iconix1,Iconix2
]

export default Iconiximages;
